import * as y from "react";
import { i as D, E as $, x as d, r as C, c as _ } from "../createReactComponent-58f9bea8.mjs";
import { n as s } from "../property-9daa16cd.mjs";
import { r as g } from "../state-7560d4dc.mjs";
import { e as I } from "../class-map-2994e95e.mjs";
import { p as E } from "../purify.es-39f8036b.mjs";
import { r as P } from "../checkbox-46b40c6a.mjs";
import { r as S } from "../dropdown-da3ba287.mjs";
import { r as O } from "../icon-c572aa57.mjs";
import { r as L } from "../menu-3df3d7c3.mjs";
import { r as T } from "../menu-item-65dd9fa4.mjs";
import { r as z } from "../tooltip-cb602d1f.mjs";
import { a as R } from "../menu-item-group-4d9c93fd.mjs";
import "../button-7600b6ca.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../icon-button-87ac6b5d.mjs";
import "../style-map-c3339321.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../radio-8b0e9514.mjs";
import "../if-defined-47693dfa.mjs";
import "../live-6c85dd15.mjs";
import "../pill-5555e08e.mjs";
import "../pill-group-b0c315ae.mjs";
import "../utils-cf5bbdd1.mjs";
const q = D`
  :host {
    --exo-component-tree-child-padding-left: calc(
      var(--parent-padding-left) + var(--exo-spacing-large)
    );
  }

  :host .main-tree-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: calc((var(--exo-size-2) - var(--exo-size-1) * 2) * 2);
    border-radius: var(--exo-spacing-2x-small);
    border-left: var(--exo-spacing-3x-small) solid transparent;
  }

  :host .tree__child-nodes > .main-tree-container {
    padding-left: var(--exo-component-tree-child-padding-left);
  }

  :host .tree__label-container {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow-x: clip;
    text-overflow: ellipsis;
    width: 100%;
  }

  :host .tree__child-nodes .tree__child-nodes > .main-tree-container {
    padding-left: calc(
      var(--exo-component-tree-child-padding-left) + var(--exo-spacing-medium)
    );
  }

  :host :focus-visible {
    outline: none;
  }

  :host ul.tree {
    padding-left: var(--exo-spacing-none);
    width: 100%;
    margin-block: var(--exo-spacing-none) var(--exo-spacing-none);
    padding-inline-start: var(--exo-spacing-none);
  }

  :host .main-tree-container:not(.selected):hover {
    background: var(--exo-color-background-action-hover-weak);
    width: 100%;
  }

  :host ex-input::part(input--container) {
    height: calc(var(--exo-size-1) / 3.2);
  }

  :host .main-tree-container.large ex-input::part(input--container) {
    height: calc(var(--exo-size-1) / 2.5);
  }

  :host .tree__with-file {
    display: flex;
    align-items: flex-start;
    padding-right: var(--exo-spacing-2x-small);
    color: var(--exo-color-background-deselected);
  }

  :host .main-tree-container.selected .tree__with-file {
    color: var(--exo-color-background-selected);
  }

  :host
    .tree__collapse-icon:not(
      .main-tree-container.selected .tree__collapse-icon
    ) {
    cursor: pointer;
    width: var(--exo-spacing-standard);
    height: var(--exo-spacing-standard);
    color: var(--exo-color-background-deselected);
    flex-shrink: var(--exo-spacing-none);
    border-radius: var(--exo-radius-standard);
    display: flex;
    padding: calc(var(--exo-spacing-small) / 2) var(--exo-spacing-none);
    justify-content: center;
    align-items: center;
  }

  :host .main-tree-container:not(.selected):hover .tree__collapse-icon {
    color: var(--exo-color-background-deselected-hover);
  }

  :host .tree-checkbox {
    padding: var(--exo-spacing-3x-small);
    height: calc(var(--exo-size-1) / 4);
    width: calc(var(--exo-size-1) / 4);
  }

  :host ex-checkbox.tree-checkbox::part(checkbox) {
    background: none;
    position: relative;
    bottom: calc(var(--exo-spacing-small) / 4);
    height: calc(var(--exo-size-1) / 4);
    width: calc(var(--exo-size-1) / 4);
  }

  :host ex-checkbox.tree-checkbox::part(checkbox):hover {
    background: none;
  }

  :host ex-input {
    width: calc(100% - var(--exo-spacing-2x-large));
    position: relative;
    left: var(--exo-spacing-3x-small);
  }

  :host ex-checkbox.tree-checkbox::part(checkbox-control) {
    position: relative;
    bottom: calc(var(--exo-spacing-small) / 2);
    right: calc(var(--exo-spacing-small) / 2);
    height: var(--exo-spacing-none);
    width: var(--exo-spacing-none);
  }

  :host .main-tree-container.large,
  :host .main-tree-container.selected.large,
  :host .main-tree-container.expanded.large {
    height: calc(var(--exo-size-1) / 2);
  }

  /* Re Order Icon  */

  :host .reorder--icon {
    position: absolute;
    display: block;
    left: calc(-1 * (var(--exo-spacing-small) / 2));
    top: var(--exo-spacing-none);
    cursor: pointer;
    border-radius: var(--exo-spacing-3x-small) var(--exo-spacing-none)
      var(--exo-spacing-none) var(--exo-spacing-3x-small);
  }

  :host .main-tree-container.selected .reorder--icon {
    background: var(--exo-color-background-selected-weak);
  }

  :host .main-tree-container .reorder--icon,
  :host .main-tree-container.expanded .tree__collapse-icon {
    background: var(--exo-color-background-action-hover-weak);
  }

  :host .main-tree-container.focused .reorder--icon {
    display: none;
  }

  /* Child nodes  */

  :host .tree__child-nodes .main-tree-container.selected {
    background: var(--exo-color-background-action-hover-weak);
  }

  :host .tree__child-nodes .main-tree-container.selected:hover {
    background: var(--exo-color-background-selected-weak);
  }

  :host .tree__child-nodes .main-tree-container.selected.focused,
  :host .main-tree-container.selected.focused {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
    background: var(--exo-color-background-action-secondary-hover);
  }

  :host span.hidden--label {
    position: absolute;
    width: var(--exo-spacing-none);
    overflow: hidden;
  }

  :host .tree-label {
    display: flex;
    align-items: center;
    font: var(--exo-text-label-standard);
    width: 100%;
    left: 1px;
    position: relative;
    color: var(--exo-color-font);
    padding: var(--exo-spacing-2x-small);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  :host .tree--main {
    list-style: none;
    position: relative;
    padding-bottom: calc(
      var(--exo-spacing-3x-small) + var(--exo-spacing-4x-small)
    );
  }

  :host .tree__with-line {
    position: absolute;
    left: calc(var(--exo-spacing-2x-small) - var(--exo-spacing-small));
    border-left: var(--exo-spacing-4x-small) solid
      var(--exo-color-border-secondary);
    height: 100%;
    bottom: var(--exo-spacing-none);
  }

  :host .main-tree-container.selected .tree__collapse-icon {
    display: flex;
    border-radius: var(--exo-radius-standard);
    padding: var(--exo-spacing-3x-small);
    background: transparent;
  }

  :host .main-tree-container.selected .tree__collapse-icon ex-icon {
    color: var(--exo-color-background-deselected);
  }

  :host .main-tree-container.selected .tree-checkbox {
    padding: var(--exo-spacing-3x-small);
  }

  :host .main-tree-container.selected {
    width: 100%;
    background: var(--exo-color-background-selected-weak);
    padding-left: var(--exo-spacing-3x-small);
  }

  :host .main-tree-container.selected:not(:hover)::before {
    content: "";
    height: var(--exo-spacing-large);
    border-radius: var(--exo-spacing-3x-small);
    background: var(--exo-color-background-selected);
    width: var(--exo-spacing-3x-small);
    position: absolute;
    left: var(--exo-spacing-none);
  }

  :host .main-tree-container.selected:hover {
    border-radius: var(--exo-spacing-none) var(--exo-spacing-2x-small)
      var(--exo-spacing-2x-small) var(--exo-spacing-none);
    border-left: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .main-tree-container.selected.focused {
    border-radius: var(--exo-spacing-2x-small);
    border-left: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .main-tree-container.selected .tree-label {
    font: var(--exo-text-label-standard-semi-bold);
    color: var(--exo-color-font);
  }

  :host .main-tree-container.focused {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
    background: var(--exo-color-background-action-hover-weak);
  }

  :host .dragging ex-tooltip::part(popup),
  :host .dragging ex-dropdown {
    display: none;
  }

  :host .main-tree-container.dragging.focused,
  :host .main-tree-container.dragging.selected.focused {
    outline: none;
  }

  :host .main-tree-container.dragover {
    background-color: var(--exo-color-background-action-secondary-hover);
    border: var(--exo-spacing-4x-small) dashed
      var(--exo-color-background-selected);
  }

  :host .tree-collapse-icon,
  :host .tree-expand-icon {
    font-size: var(--exo-spacing-small);
  }

  :host .no-child {
    margin-left: var(--exo-spacing-standard);
  }

  :host .tree__child-nodes {
    padding-left: var(--exo-spacing-large);
  }
`;
var U = Object.defineProperty, A = Object.getOwnPropertyDescriptor, a = (l, e, o, t) => {
  for (var n, i = t > 1 ? void 0 : t ? A(e, o) : e, c = l.length - 1; c >= 0; c--)
    (n = l[c]) && (i = (t ? n(e, o, i) : n(i)) || i);
  return t && i && U(e, o, i), i;
};
class r extends $ {
  constructor() {
    super(...arguments), this.draggedNode = null, this.dragOverNode = null, this.dragParentNode = null, this.openDropdownNode = null, this.editingNode = null, this.focusedNode = null, this.dragging = null, this.icon = "", this.collapseIcon = "direction-arrowhead-right", this.expandIcon = "direction-arrowhead-down", this.enableDragAndDrop = !1, this.showDropdown = !1, this.treeData = [], this.hoveredNode = null, this.showCheckboxes = !1, this.doubleClickEdit = !1, this.showIcon = !1, this.size = "medium", this.showTreeLine = !1, this.labelLength = 32, this.tooltipText = "", this.collapseIconLabel = "", this.expandIconLabel = "", this.reorderIconLabel = "", this.selectedNode = null;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("keydown", this.handleKeyDown), this.expandParentsOfSelectedNode(this.treeData);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("keydown", this.handleKeyDown);
  }
  firstUpdated() {
    this.scrollToSelectedNode();
  }
  scrollToSelectedNode() {
    var e, o;
    (o = (e = this.shadowRoot) == null ? void 0 : e.querySelector(".selected")) == null || o.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }
  handleKeyDown(e) {
    if (this.focusedNode)
      switch (e.key) {
        case "ArrowUp":
          this.focusPreviousNode(this.focusedNode);
          break;
        case "ArrowDown":
          this.focusNextNode(this.focusedNode);
          break;
        case "ArrowRight":
          this.expandNode(this.focusedNode);
          break;
        case "ArrowLeft":
          this.collapseNode(this.focusedNode);
          break;
        case " ":
          this.handleNodeSelection(this.focusedNode);
      }
  }
  focusPreviousNode(e) {
    if (!e)
      return;
    const o = this.flattenTree(this.treeData), t = o.indexOf(e);
    if (t > 0) {
      const n = o[t - 1];
      this.focusNode(n);
    }
  }
  focusNextNode(e) {
    if (!e)
      return;
    const o = this.flattenTree(this.treeData), t = o.indexOf(e);
    if (t < o.length - 1) {
      const n = o[t + 1];
      this.focusNode(n);
    }
  }
  flattenTree(e) {
    const o = [];
    return e.forEach((t) => {
      o.push(t), t.children && t.expanded && o.push(...this.flattenTree(t.children));
    }), o;
  }
  focusNode(e) {
    var t;
    if (!e)
      return;
    this.focusedNode = e;
    const o = (t = this.shadowRoot) == null ? void 0 : t.querySelector(`[data-label="${e.label}"]`);
    o && o.focus();
  }
  treeCollapseIcon() {
    return d`<ex-icon
      class="tree-collapse-icon"
      icon=${this.collapseIcon}
      label=${this.collapseIconLabel}
    ></ex-icon> `;
  }
  treeExpandIcon() {
    return d`<ex-icon
      class="tree-expand-icon"
      icon=${this.expandIcon}
      label=${this.expandIconLabel}
    ></ex-icon> `;
  }
  onClick(e) {
    this.dispatchCustomEvent("onClick", { node: e });
  }
  onExpand(e) {
    this.dispatchCustomEvent("onExpand", { node: e });
  }
  onCollapse(e) {
    this.dispatchCustomEvent("onCollapse", { node: e });
  }
  handleDragStart(e, o, t) {
    var n;
    this.enableDragAndDrop ? ((n = e.dataTransfer) == null || n.setData("text/plain", JSON.stringify(o)), this.draggedNode = o, this.dragParentNode = t, this.dragging = o, this.handleDropdownClose(), e.stopPropagation()) : e.preventDefault();
  }
  handleDragOver(e, o) {
    e.preventDefault(), e.stopPropagation(), this.draggedNode && this.draggedNode !== o && (this.dragOverNode = o), this.dragOverNode = o, this.requestUpdate();
  }
  handleDrop(e, o) {
    var t, n, i;
    e.preventDefault(), e.stopPropagation(), this.draggedNode && this.dragParentNode && (t = this.draggedNode, i = o, (n = this.dragParentNode).children = n.children.filter((c) => c !== t), i.children ? i.children.push(t) : i.children = [t], this.requestUpdate()), this.draggedNode = null, this.dragging = null, this.focusedNode = null, this.dragOverNode = null, this.dragParentNode = null;
  }
  handleNodeSelection(e) {
    this.selectedNode === e ? (this.selectedNode.selected = !1, this.selectedNode = null) : (this.selectedNode && (this.selectedNode.selected = !1), e.selected = !0, this.selectedNode = e), this.onClick(e), this.deselectAllOtherNodes(this.treeData, e), this.requestUpdate();
  }
  deselectAllOtherNodes(e, o) {
    e.forEach((t) => {
      t !== o && (t.selected = !1, t.children && this.deselectAllOtherNodes(t.children, o));
    });
  }
  handleRenameClick(e) {
    (this.doubleClickEdit || this.showDropdown) && (e.editing = !0, this.editingNode = e, this.requestUpdate());
  }
  handleNodeMouseEnter(e) {
    this.openDropdownNode || e.editing || (this.hoveredNode = e, this.requestUpdate());
  }
  handleNodeMouseLeave(e) {
    this.openDropdownNode || e.editing || (this.hoveredNode = null, this.requestUpdate());
  }
  handleNodeFocus(e) {
    this.focusedNode = e, this.requestUpdate();
  }
  handleNodeBlur(e) {
    this.focusedNode === e && (this.focusedNode = null);
  }
  handleDropdownOpen(e) {
    this.openDropdownNode === e ? this.openDropdownNode = null : this.openDropdownNode = e;
  }
  handleDropdownClose() {
    this.openDropdownNode = null, this.hoveredNode = null;
  }
  renderChildNodes(e, o) {
    return e.children && e.children.length !== 0 && e.expanded ? e.children.map((t) => this.renderNode(t, e, o + 1)) : [];
  }
  labelRendererWithExoTooltip(e) {
    const o = E.sanitize(e.label), t = (n = this.labelLength, (i = o).length > n ? `${i.substring(0, n)}...` : i);
    var n, i;
    return t !== o ? d`<ex-tooltip>
        <span
          style="white-space: initial; word-break: break-word;display: flex;width: 200px;"
        >
          ${o}
        </span>
        <span slot="anchor">${t}</span>
      </ex-tooltip>` : o;
  }
  getDropdown(e) {
    return d`
      <ex-dropdown
        icon="More options"
        type="tertiary"
        tooltipText=${this.tooltipText}
        .open=${e === this.openDropdownNode}
        @open-dropdown="${() => {
      this.hoveredNode = e, this.handleDropdownOpen(e);
    }}"
        @close-dropdown="${() => {
      this.handleDropdownClose();
    }}"
      >
        <ex-menu>
          <ex-menu-item @click=${() => this.handleRenameClick(e)}>
            Rename
          </ex-menu-item>
          <ex-menu-item>Option 1</ex-menu-item>
          <ex-menu-item>Option 2</ex-menu-item>
        </ex-menu>
      </ex-dropdown>
    `;
  }
  getReorderIcon(e) {
    return this.enableDragAndDrop && e === this.hoveredNode && !this.openDropdownNode ? d`<ex-icon
          class="reorder--icon"
          icon="Reorder"
          label=${this.reorderIconLabel}
        ></ex-icon>` : d``;
  }
  getDropdownContent(e) {
    return !this.showDropdown || e !== this.hoveredNode && e !== this.focusedNode || e.editing ? d`` : this.getDropdown(e);
  }
  renderLabelContent(e, o, t) {
    var n;
    return e.editing ? d`
        <ex-input
          class="input"
          type="text"
          .value=${e.label}
          @input=${(i) => function(c, p) {
      const u = c.target;
      p.label = u.value;
    }(i, e)}
          @dblclick=${() => this.handleDoubleClick(e)}
          @blur=${() => this.toggleEditing(e, !1)}
        />
      ` : d`
      <div
        class=${I({ "tree-label": !0, "no-child": o === 0 && (e == null ? void 0 : e.children) === void 0 || ((n = e == null ? void 0 : e.children) == null ? void 0 : n.length) === 0 })}
        @dblclick=${() => this.handleDoubleClick(e)}
        @click=${() => {
      this.handleNodeSelection(e);
    }}
        @mouseenter=${() => this.handleNodeMouseEnter(e)}
      >
        ${t}${this.renderShowIcon(e)}
        ${this.labelRendererWithExoTooltip(e)}
      </div>
    `;
  }
  renderConnector(e) {
    return this.showTreeLine && e > 0 ? d`<div class="tree__with-line"></div>` : "";
  }
  renderShowIcon(e) {
    return this.showIcon && e.icon ? d`<ex-icon
        class="tree__with-file"
        icon=${e.icon}
        size="XS"
        label=${e.iconLabel}
      ></ex-icon>` : "";
  }
  renderExpandCollapseIcon(e) {
    const o = e.children && e.children.length > 0, t = e.expanded ? this.treeExpandIcon() : this.treeCollapseIcon();
    return o ? d`
          <div
            class="tree__collapse-icon"
            @click=${() => e.expanded ? this.collapseNode(e) : this.expandNode(e)}
          >
            ${t}
          </div>
        ` : "";
  }
  renderNode(e, o, t = 0) {
    var v;
    const n = e.selected ? "selected" : "", i = e.expanded ? "expanded" : "", c = e === this.focusedNode ? "focused" : "", p = e === this.dragging ? "dragging" : "", u = this.dragOverNode === e ? "dragover" : "", m = this.size === "large" ? "large" : "", b = `${n} ${i} ${c} ${p} ${u}`, f = e.children && e.children.length > 0, N = this.renderChildNodes(e, t), x = (v = e.children) == null ? void 0 : v.map((h) => h.checked || h.indeterminate), k = this.showCheckboxes ? d`
          <ex-checkbox
            class="tree-checkbox"
            .checked=${e.checked}
            .indeterminate=${(x == null ? void 0 : x.includes(!0)) && !(x != null && x.every(Boolean))}
            @on-change=${(h) => this.handleCheckboxChange(h, e)}
          >
          </ex-checkbox>
        ` : d``, w = this.renderLabelContent(e, t, k);
    return d`
      <li
        class="tree--main"
        draggable="true"
        @dragstart=${(h) => this.handleDragStart(h, e, o)}
        @dragover=${(h) => this.handleDragOver(h, e)}
        @drop=${(h) => this.handleDrop(h, e)}
        @mouseenter=${() => this.handleNodeMouseEnter(e)}
        @mouseleave=${() => this.handleNodeMouseLeave(e)}
      >
        <div
          class="main-tree-container ${b} ${m}"
          @focus=${() => this.handleNodeFocus(e)}
          @blur=${() => this.handleNodeBlur(e)}
          @mouseenter=${() => this.handleNodeMouseEnter(e)}
          tabindex="0"
        >
          ${this.getReorderIcon(e)} ${this.renderExpandCollapseIcon(e)}
          <div class="tree__label-container" ${n}>${w}</div>
          ${this.getDropdownContent(e)}
        </div>
        ${this.renderConnector(t)}
        ${f ? d`<ul class="tree__child-nodes">
              ${N}
            </ul>` : ""}
      </li>
    `;
  }
  handleDoubleClick(e) {
    this.doubleClickEdit && !this.editingNode && (this.editingNode = e, e.editing = !0, this.requestUpdate());
  }
  toggleEditing(e, o) {
    o ? (this.editingNode = e, e.editing = o) : e === this.editingNode && (this.editingNode = null, e.editing = o), this.requestUpdate();
  }
  expandNode(e) {
    e.expanded || (e.expanded = !0, this.onExpand(e), this.requestUpdate());
  }
  collapseNode(e) {
    e.expanded && (e.expanded = !1, this.onCollapse(e), this.requestUpdate());
  }
  handleCheckboxChange(e, o) {
    const t = e.target.checked;
    this.updateNodeCheckedState(o, t), this.updateParentIndeterminateState(o), this.requestUpdate();
  }
  updateNodeCheckedState(e, o) {
    e.checked = o, e.children && e.children.length && e.children.forEach((t) => this.updateNodeCheckedState(t, o));
  }
  updateParentIndeterminateState(e) {
    var t, n;
    const o = this.findParentNode(e);
    if (o) {
      const i = ((t = o.children) == null ? void 0 : t.every((p) => p.checked)) ?? !1, c = ((n = o.children) == null ? void 0 : n.some((p) => p.checked || p.indeterminate)) ?? !1;
      o.checked = i, o.indeterminate = c && !i, this.updateParentIndeterminateState(o);
    }
  }
  updateAllParentsIndeterminateState() {
    this.treeData.forEach((e) => {
      this.updateParentIndeterminateState(e);
    });
  }
  findParentNode(e) {
    for (const o of this.treeData) {
      const t = this.findParentNodeRecursive(o, e);
      if (t)
        return t;
    }
    return null;
  }
  findParentNodeRecursive(e, o) {
    if (e.children && e.children.includes(o))
      return e;
    for (const t of e.children || []) {
      const n = this.findParentNodeRecursive(t, o);
      if (n)
        return n;
    }
    return null;
  }
  expandParentNodes(e) {
    let o = e;
    for (; o; )
      o.expanded = !0, o = this.findParentNode(o);
  }
  expandParentsOfSelectedNode(e) {
    e.forEach((o) => {
      o.selected || o.expanded ? this.expandParentNodes(o) : o.children && this.expandParentsOfSelectedNode(o.children);
    });
  }
  render() {
    return d`
      <ul class="tree">
        ${this.treeData.map((e) => this.renderNode(e, null, 0))}
      </ul>
    `;
  }
}
r.styles = q, a([g()], r.prototype, "draggedNode", 2), a([g()], r.prototype, "dragOverNode", 2), a([g()], r.prototype, "dragParentNode", 2), a([g()], r.prototype, "openDropdownNode", 2), a([g()], r.prototype, "editingNode", 2), a([g()], r.prototype, "focusedNode", 2), a([g()], r.prototype, "dragging", 2), a([s()], r.prototype, "icon", 2), a([s()], r.prototype, "collapseIcon", 2), a([s()], r.prototype, "expandIcon", 2), a([s({ type: Boolean })], r.prototype, "enableDragAndDrop", 2), a([s({ type: Boolean })], r.prototype, "showDropdown", 2), a([s({ type: Array })], r.prototype, "treeData", 2), a([s({ type: Object })], r.prototype, "hoveredNode", 2), a([s({ type: Boolean })], r.prototype, "showCheckboxes", 2), a([s({ type: Boolean })], r.prototype, "doubleClickEdit", 2), a([s({ type: Boolean })], r.prototype, "showIcon", 2), a([s({ type: String })], r.prototype, "size", 2), a([s({ type: Boolean })], r.prototype, "showTreeLine", 2), a([s({ type: Number })], r.prototype, "labelLength", 2), a([s({ type: String })], r.prototype, "tooltipText", 2), a([s({ type: String })], r.prototype, "collapseIconLabel", 2), a([s({ type: String })], r.prototype, "expandIconLabel", 2), a([s({ type: String })], r.prototype, "reorderIconLabel", 2);
const B = (l = "") => {
  C("ex-tree", r, l), P(l), S(l), O(l), L(l), T(l), z(l), R(l);
}, he = _({ tagName: "ex-tree", elementClass: r, react: y, events: { onClick: "onClick", onExpand: "onExpand", onCollapse: "onCollapse" }, displayName: "ExTree", registerWebComponent: B });
export {
  he as ExTree,
  B as register
};
